import { createI18n } from "vue-i18n";
import {
  errors,
  errorPages,
  validation,
} from "lang/ja";

const I18N_LOCALSE = process.env.I18N_LOCALSE || "ja";

// I18nの設定
const messages = {
  ja: {
    errors,
    errorPages,
    validation,
  },
};

const i18n = createI18n({
  locale: I18N_LOCALSE,
  fallbackLocale: "ja",
  messages,
});

export default i18n;
